<div *ngIf="areas">
  <div class="bg-white pt-3 ml-2">
    <div class="text-bidit-primary font-weight-bold" i18n>Areas & Sub Areas:</div>
    <div class="row">
      <div class="col-sm-8" i18n>
        <span class="text-bidit-primary font-weight-bold">Areas</span> are grouped locations you install insulation into a project (Ceiling, walls, floor, basement). <span class="text-bidit-primary font-weight-bold">Sub Areas</span> determine the labor costs for a quote. You may add or modify both below.
      </div>
      <div class="col-sm-4 float-right">
        <div>
          <a (click)="showAreaEdit(null)" class="btn btn-bidit-navigate btn-md mb-sm-3" i18n>Add New Area</a>
        </div>
        <div>
          <a (click)="showSubAreaEdit(null)" class="btn btn-bidit-navigate btn-md mb-sm-3" i18n>Add New Sub Area</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <span i18n>Hide Inactive</span>
        <input (change)="toggleAreaFilter()" type="checkbox"
               name="showActive" class="bidit-switch-sm ml-1 mr-1" [checked]="showActive">
        <target i18n>Show All</target>
      </div>
    </div>
    <div cdkDropList [cdkDropListData]="areas" (cdkDropListDropped)="dropArea($event)">
      <div cdkDrag [cdkDragDisabled]="area.area_Sort == 99" *ngFor="let area of areas" >
        <div class="form-inline area-header mt-3">
          <a (click)="showAreaEdit(area.area_ID)" class="btn-bidit-edit-dark"></a>
          <span class="text-bidit-primary font-weight-bold ml-1 mr-5">Area: {{area.area_Name}}</span>
          <div class="form-inline">
            <ng-container *ngIf="area.area_IsOption; then optionsArea; else defaultArea"></ng-container>
            <ng-template #defaultArea>
              <label id="area_status_active{{area.area_ID}}" [ngClass]="{'text-success' : area.area_IsActive}" i18n>active</label>
              <input (change)="toggleAreaStatus('Area', area.area_ID)" type="checkbox" name="area_status_{{area.area_ID}}"
                     id="area_status{{area.area_ID}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!area.area_IsActive" (ngModelChange)="area.area_IsActive = $event" [disabled]="area.area_IsOption ? 'disabled' : null " />
              <label id="area_status_inactive{{area.area_ID}}" [ngClass]="{'text-danger' : !area.area_IsActive}" i18n>inactive</label>
            </ng-template>
            <ng-template #optionsArea>
              <label class="text-success mr-2" i18n>active</label>
              <div class="info-icon" i18n-matTooltip
                   matTooltip="Options area cannot be edited or inactivated.  For more info please contact Bidit support."></div>
            </ng-template>
          </div>
        </div>
        <div *ngIf="!this.isIDIAdmin || (this.isIDIAdmin && this.dealerId !== null)">
          <mat-table class="table compact table-bidit table-border" [dataSource]="area.subAreas"
                     cdkDropList
                     [cdkDropListData]="area.subAreas"
                     (cdkDropListDropped)="dropSubArea(area.area_ID,  $event)">
            <ng-container matColumnDef="subArea_Name">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Sub Areas</mat-header-cell>
              <mat-cell *matCellDef="let subArea">
                {{ subArea.subArea_Name}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Status</mat-header-cell>
              <mat-cell *matCellDef="let subArea">
                <div class="form-inline">
                  <label id="subarea_status_active{{subArea.subArea_ID}}" [ngClass]="{'text-success' : subArea.subArea_IsActive}" i18n>active</label>
                  <input (change)="toggleSubAreaStatus('SubArea', subArea.area_ID, subArea.subArea_ID)" type="checkbox" name="subarea_status_{{subArea.subArea_ID}}" id="subareastatus_{{subArea.subArea_ID}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!subArea.subArea_IsActive" (ngModelChange)="subArea.subArea_IsActive = $event">
                  <label id="subarea_status_inactive{{subArea.subArea_ID}}" [ngClass]="{'text-danger' : !subArea.subArea_IsActive}" i18n>inactive</label>
                  <span class="border-left-0 btn-bidit-edit-dark ml-5" (click)="showSubAreaEdit(subArea.subArea_ID)"></span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="noRecord">
              <td mat-footer-cell *matFooterCellDef class="w-100">No subareas</td>
            </ng-container>
            <ng-template [ngIf]="area.subAreas.length === 0">
              <tr mat-footer-row *matFooterRowDef="['noRecord']" style="display: flex"></tr>
            </ng-template>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"  cdkDrag [cdkDragData]="row" [cdkDragDisabled]="area.area_Sort == 99"></mat-row>
          </mat-table>
        </div>
      </div>
    </div>
  </div>
</div>
